import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import mainpage_ko from './locales/ko/mainpage.json';
import mainpage_en from './locales/en/mainpage.json';
import mainpage_ja from './locales/ja/mainpage.json';
import mainpage_zh from './locales/zh/mainpage.json';

import menupage_ko from './locales/ko/menupage.json';
import menupage_en from './locales/en/menupage.json';
import menupage_ja from './locales/ja/menupage.json';
import menupage_zh from './locales/zh/menupage.json';

import lockerlocations_ko from './locales/ko/lockerlocations.json';
import lockerlocations_en from './locales/en/lockerlocations.json';
import lockerlocations_ja from './locales/ja/lockerlocations.json';
import lockerlocations_zh from './locales/zh/lockerlocations.json';

import reservationinfo_ko from './locales/ko/reservationinfo.json';
import reservationinfo_en from './locales/en/reservationinfo.json';
import reservationinfo_ja from './locales/ja/reservationinfo.json';
import reservationinfo_zh from './locales/zh/reservationinfo.json';

import payment_ko from './locales/ko/payment.json';
import payment_en from './locales/en/payment.json';
import payment_ja from './locales/ja/payment.json';
import payment_zh from './locales/zh/payment.json';

import lockerprocessing_ko from './locales/ko/lockerprocessing.json';
import lockerprocessing_en from './locales/en/lockerprocessing.json';
import lockerprocessing_ja from './locales/ja/lockerprocessing.json';
import lockerprocessing_zh from './locales/zh/lockerprocessing.json';

import lockercomplete_ko from './locales/ko/lockercomplete.json';
import lockercomplete_en from './locales/en/lockercomplete.json';
import lockercomplete_ja from './locales/ja/lockercomplete.json';
import lockercomplete_zh from './locales/zh/lockercomplete.json';

import passwordinput_ko from './locales/ko/passwordinput.json';
import passwordinput_en from './locales/en/passwordinput.json';
import passwordinput_ja from './locales/ja/passwordinput.json';
import passwordinput_zh from './locales/zh/passwordinput.json';

import footer_ko from './locales/ko/footer.json';
import footer_en from './locales/en/footer.json';
import footer_ja from './locales/ja/footer.json';
import footer_zh from './locales/zh/footer.json';

import privacy_ko from './locales/ko/privacy.json';
import privacy_en from './locales/en/privacy.json';
import privacy_ja from './locales/ja/privacy.json';
import privacy_zh from './locales/zh/privacy.json';

if (!sessionStorage.getItem("langSession")) {
  localStorage.setItem("i18nextLng", "ko");			// i18n이 사용하는 언어 코드
  localStorage.setItem("lang", "KR");						// 드롭다운용 언어 코드
  sessionStorage.setItem("langSession", "true");		// 세션 내에서는 변경 유지
}

const defaultLang = localStorage.getItem("i18nextLng") || "ko";

i18n
  .use(LanguageDetector)      // 브라우저에서 언어 감지
  .use(initReactI18next)			// React 연동
  .init({
    resources: {
      ko: {
        mainpage: mainpage_ko,
		menupage:	menupage_ko,
		lockerlocations: lockerlocations_ko,
		reservationinfo: reservationinfo_ko,
		payment: payment_ko,
		lockerprocessing: lockerprocessing_ko,
		lockercomplete: lockercomplete_ko,
		passwordinput: passwordinput_ko,
		footer: footer_ko,
		privacy: privacy_ko
      },
      en: {
        mainpage: mainpage_en,
		menupage:	menupage_en,
		lockerlocations: lockerlocations_en,
		reservationinfo: reservationinfo_en,
		payment: payment_en,
		lockerprocessing: lockerprocessing_en,
		lockercomplete: lockercomplete_en,
		passwordinput: passwordinput_en,
		footer: footer_en,
		privacy: privacy_en
      },
      ja: {
        mainpage: mainpage_ja,
		menupage:	menupage_ja,
		lockerlocations: lockerlocations_ja,
		reservationinfo: reservationinfo_ja,
		payment: payment_ja,
		lockerprocessing: lockerprocessing_ja,
		lockercomplete: lockercomplete_ja,
		passwordinput: passwordinput_ja,
		footer: footer_ja,
		privacy: privacy_ja
      },
      zh: {
        mainpage: mainpage_zh,
		menupage:	menupage_zh,
		lockerlocations: lockerlocations_zh,
		reservationinfo: reservationinfo_zh,
		payment: payment_zh,
		lockerprocessing: lockerprocessing_zh,
		lockercomplete: lockercomplete_zh,
		passwordinput: passwordinput_zh,
		footer: footer_zh,
		privacy: privacy_zh
      }
    },
    lng: defaultLang,				// 기본 언어: 한국어
    fallbackLng: 'ko',				// fallback도 한국어

    ns: ['mainpage', 'menupage', 'lockerlocations', 'reservationinfo', 'payment', 'lockerprocessing', 'lockercomplete', 'passwordinput', 'footer', 'privacy'],		// namespace 사용 시 정의
    defaultNS: 'mainpage',     // 기본 namespace

    interpolation: {
      escapeValue: false			// React에서 XSS 방지 필요 없음
    },

    detection: {
      order: ['localStorage', 'navigator'],  // 언어 감지 우선순위
      caches: ['localStorage']
    }
  });

export default i18n;
